export const isExtendedIncaErrand = (incaErrand)=>{
    return !!incaErrand?.action;
};
export const incaAccessor = ()=>{
    return globalThis.inca;
};
